module.exports = __webpack_public_path__ + "img/avatar-img.f217c093.svg";